import { PlanFeature } from '../../models/plan-feature.model';

export const FEATURE_PLAN_BASIC: PlanFeature[] = [
  PlanFeature.DataDashboard,
  PlanFeature.AdminDashboard,
  PlanFeature.OrderManagement,
  PlanFeature.OrderTracking,
  PlanFeature.BarcodeReader,
  PlanFeature.Notifications,
  PlanFeature.PackageRecords,
];

export const FEATURE_PLAN_INTEGRATED: PlanFeature[] = [
  PlanFeature.DataDashboard,
  PlanFeature.AdminDashboard,
  PlanFeature.OrderManagement,
  PlanFeature.OrderTracking,
  PlanFeature.BarcodeReader,
  PlanFeature.Notifications,
  PlanFeature.PackageRecords,
  PlanFeature.ProviderClientsManagement,
  PlanFeature.ClientIntegration,
];

export const FEATURE_PLAN_PREMIUM: PlanFeature[] = [
  PlanFeature.DataDashboard,
  PlanFeature.AdminDashboard,
  PlanFeature.OrderManagement,
  PlanFeature.OrderTracking,
  PlanFeature.BarcodeReader,
  PlanFeature.Notifications,
  PlanFeature.PackageRecords,
  PlanFeature.ProviderClientsManagement,
  PlanFeature.PackageLabelPrinting,
  PlanFeature.QrReader,
  PlanFeature.MapDisplay,
  PlanFeature.ExportData,
];
